export default "__VITE_ASSET__DT2uI5IS__"